/*
Calendar-week grouping.

The server renders a flat list of post cards (.post[data-week][data-type]) inside
`.gh-postfeed[data-kw-group]`. Handlebars can't nest them into per-week wrappers
server-side, so this module does it in the browser: consecutive cards that share a
`data-week` value are moved into a single <section class="kw-group">, whose header
is the centered "shelf tab" (KW + year) shown in the wireframe.

Filtering by media type is now handled by real tag pages (All / pictures / videos /
words) linked from the header — there is no in-page filter anymore.

`distribute()` is exported so infiniteScroll.js can feed appended cards through the
same logic, extending the last week group or starting a new one as needed.
*/

// "2026-W29" -> { year: "2026", kw: "29" }
function parseWeek(weekKey) {
    const match = /^(\d{4})-W(\d{1,2})$/.exec(weekKey || '');
    if (!match) {
        return { year: '', kw: '' };
    }
    return { year: match[1], kw: String(parseInt(match[2], 10)) };
}

// Build an empty week wrapper (shelf tab + posts container) and append it to the feed.
function buildGroup(feed, weekKey) {
    const { year, kw } = parseWeek(weekKey);

    const section = document.createElement('section');
    section.className = 'kw-group';
    section.setAttribute('data-week', weekKey);

    // The "shelf tab" that protrudes from the top-centre of the group (see wireframe).
    const head = document.createElement('header');
    head.className = 'kw-group-head';

    const title = document.createElement('div');
    title.className = 'kw-group-title';
    title.innerHTML =
        '<span class="kw-group-kw">Week ' + kw + ',</span> ' +
        '<span class="kw-group-year">' + year + '</span>';

    head.appendChild(title);

    const posts = document.createElement('div');
    posts.className = 'kw-group-posts';

    section.appendChild(head);
    section.appendChild(posts);
    feed.appendChild(section);

    return section;
}

function lastGroup(feed) {
    const groups = feed.querySelectorAll(':scope > .kw-group');
    return groups.length ? groups[groups.length - 1] : null;
}

// Move each card into the matching week group, creating a new group when the week changes.
export function distribute(feed, cards) {
    cards.forEach(function (card) {
        const weekKey = card.getAttribute('data-week');
        let group = lastGroup(feed);

        if (!group || group.getAttribute('data-week') !== weekKey) {
            group = buildGroup(feed, weekKey);
        }

        group.querySelector('.kw-group-posts').appendChild(card);
    });
}

export default function weekGroups() {
    const feeds = document.querySelectorAll('.gh-postfeed[data-kw-group]');

    feeds.forEach(function (feed) {
        const cards = Array.from(feed.querySelectorAll(':scope > .post'));
        distribute(feed, cards);
    });
}
